import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { WhyInfolocus } from "@/components/site/WhyInfolocus";
import { Industries } from "@/components/site/Industries";
import { Process } from "@/components/site/Process";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

const Landing = () => (
  <div className="App" data-testid="landing-page">
    <Header />
    <main>
      <Hero />
      <Services />
      <WhyInfolocus />
      <Industries />
      <Process />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
    <WhatsAppButton />
    <Toaster richColors position="top-right" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
